import React, { useState, useEffect } from 'react';

import { Dropdown, FormGroupRadio } from "components";

import { convertArrayToDropdownArrayFormat, func_validation, getObjectPropertyValue, isArrayNotEmpty, isStringTrimNotEmpty } from "functions";
import { FormCheckbox } from 'components/form/formCheckbox/FormCheckbox';
import { Toaster } from 'components/notification/Toaster';

export function useProductInputs(props) {
    // Props

    let { 
        isEditing,
        billingSetup,
        
        isFormSubmissionAttempted,
        isDraft,
    
        // productCodeList,
        // productNameList,
        fullProductCodeList: productCodeList,
        getFullProductDetailList_errorMsg,
        
        // Functions
        getFullProductDetailList = () => {}
    } = props;

    let productCode_original = getObjectPropertyValue(billingSetup, "ProductCode");
    let productName_original = getObjectPropertyValue(billingSetup, "ProductName");

    // States
    const [productCode, setProductCode] = useState(productCode_original);
    const [productName, setProductName] = useState(productName_original);
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);

    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            productCode === productCode_original &&
            productName === productName_original
        );

        let isChangedFromEmpty = (
            productCode || productName
        );

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);
    }, [
        productCode, productName
    ]);

    // Get full list
    useEffect(() => {
        getFullProductDetailList();
    }, []);

    let productCodeList_formatted = [];
    if (isArrayNotEmpty(productCodeList)) {
        productCodeList_formatted = productCodeList.map((obj) => {
            return {
                label: obj?.ProductCode,
                value: obj?.ProductCode
            }
        })
    }
    

    // Display
    let display = (
        <div className={"recursiveBillingSetupAccountUpdate-product d-flex flex-wrap"}>
            {/* Product Code */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-productCode"}
                label={"Product Code"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-productCode-input"}

                options={productCodeList_formatted}
                selectedValue_default={productCode}
                onChange={(value) => {
                    setProductCode(value);
                }}
                onBlur={(value) => {
                    if (isArrayNotEmpty(productCodeList)) {
                        let isMatchFound = false;
                        productCodeList.map((obj) => {
                            if (value === obj?.ProductCode) {
                                setProductName(obj?.ProductName);
                                isMatchFound = true;
                            }
                        });

                        if (!isMatchFound) {
                            setProductName("");

                            Toaster({
                                type: "info",
                                msg: "Product code must match option from the dropdown list",
                                timer: 10000
                            })
                        }
                    }
                }}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isSearchable
                isDisabled={isEditing && !isDraft}
            />

            {/* Product Name */}
            <Dropdown
                className={"recursiveBillingSetupAccountUpdate-productName"}
                label={"Product Name"}
                isInputRequired

                selectedValueClassName={"recursiveBillingSetupAccountUpdate-productName-input"}

                // options={productNameList}
                selectedValue_default={productName}
                valueFromParent={productName}
                onChange={setProductName}

                errorMsg={"Required"}

                isFormSubmissionAttempted={isFormSubmissionAttempted}
                isSearchable
                isDisabled={!getFullProductDetailList_errorMsg || isEditing} // allow user to edit this input if list fails to load 
            />
        </div>
    );

    let isEveryInputValid = (
        isStringTrimNotEmpty(productCode) &&
        isStringTrimNotEmpty(productName)
    );

    let productDetails = {
        ProductCode: productCode,
        ProductName: productName,
    }

    return {
        productCode, 
        productName, 
        productDetails,

        isEveryInputValid,
        isAnyInputChanged,

        display
    }
}